import type { InProgressMessage, Message } from "@/types";

/** Keep partial assistant text from Dust snapshot when server messages lag behind. */
export function mergeInProgressSnapshotIntoMessages(
  messages: Message[],
  inProgress: InProgressMessage | null | undefined
): Message[] {
  if (!inProgress?.sId?.trim()) {
    return messages;
  }
  const messageId = inProgress.sId.trim();
  const snapshot = inProgress.snapshotContent ?? "";
  const out = [...messages];

  let idx = out.findIndex(
    (message) =>
      message.role === "assistant" && String(message.id) === messageId
  );
  if (idx < 0) {
    idx = out.findLastIndex((message) => message.role === "assistant");
  }

  if (idx < 0) {
    if (!snapshot.trim()) {
      return out;
    }
    out.push({
      id: messageId,
      role: "assistant",
      content: snapshot,
      timestamp: new Date(),
    });
    return out;
  }

  const existing = out[idx]!;
  const existingLen = existing.content?.length ?? 0;
  const mergedContent =
    existingLen >= snapshot.length ? existing.content : snapshot;

  out[idx] = {
    ...existing,
    id: messageId,
    content: mergedContent ?? "",
  };
  return out;
}
